module.exports = __webpack_public_path__ + "static/media/chat.c2888dcd.svg";